import { useAuthStore } from '../store/storeAuth';

export const useDarkMode = (): boolean => {
    const authUser = useAuthStore(state => state.user);
    return authUser?.theme === 'dark';
};

